import { render, staticRenderFns } from "./ThgProcessDescriptionCard.vue?vue&type=template&id=58a7b295&scoped=true"
import script from "./ThgProcessDescriptionCard.vue?vue&type=script&lang=ts"
export * from "./ThgProcessDescriptionCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a7b295",
  null
  
)

export default component.exports